<template lang="pug">
  section(id="reviews")
     .goscontainer
        v-container
          .heading Отзывы судейского сообщества:

        v-slide-group(light show-arrows)
          v-slide-item( v-for="(d, i) in reviews" :key="i" v-slot="{ active, toggle }")
            div.card.mx-2(@click="open(d)") 
              v-row(no-gutters)
                v-col.pr-4(cols="6") {{d.title}} 
                v-col(cols="6") 
                  v-img(:src="require(`@/assets/img/home/${d.img}`)" max-width="218")

     app-dialog(v-model="dialog" :header="title" max-width="700")
       v-img(v-if="dialog" :src="require(`@/assets/img/home/${img}`)" max-width="700")
            
</template>

<script>
  export default {
    name: 'SectionReviews',
    data: () => ({
      dialog: false,
      img: '',
      title: '',
      reviews: [
        {
          title: 'Совет судей Санкт-Петербурга',
          img: 'd1.png',
        },
        {
          title: 'ФГБУ ИАЦ "Судебного департамента" в Санкт-Петербурге',
          img: 'd2.png',
        },
        {
          title: 'Колпинский районный суд города Санкт-Петербурга',
          img: 'd2.png',
        },
        {
          title: 'Совет судей Санкт-Петербурга1',
          img: 'd1.png',
        },
        {
          title: 'ФГБУ ИАЦ "Судебного департамента" в Санкт-Петербурге1',
          img: 'd2.png',
        },
        {
          title: 'Колпинский районный суд города Санкт-Петербурга1',
          img: 'd2.png',
        },
      ],
    }),
    methods: {
      open (d) {
        this.img = d.img
        this.title = d.title
        this.dialog = true
      } 
    },
  }
</script>

<style lang="sass" scoped>
  #reviews
    padding: 16px 16px 32px 16px 
    background-color: #F3F3F3
    color: #000000
    .heading 
        font-family: $slab
        font-weight: 300
        font-size: 32px
        margin-bottom: 16px
        color:#505254
    .card
        white-space: normal
        font-family: $slab
        font-weight: 300
        font-size: 14px
        width: 418px
        background-color: #0E9DBC
        color: #FFFFFF
        padding: 32px 20px 0 32px
</style>
